<div class="card overflow-auto">
    <utclub-table #utclubTable [columns]="columns" [dataSource]="dataSource" [(pageSize)]="pageSize" [(pageIndex)]="pageIndex"
        [totalItemCount]="totalItemCount" [loading]="loading" (pageChanged)="pageChanged()"
        [(filterModel)]="filterModel" [filterFields]="filterFields" (filter)="loadData()">
    </utclub-table>
</div>